(() => {
  const initDxLp = () => {
    const lp = document.querySelector('[data-dx-lp]');
    if (!lp || lp.dataset.initialized === 'true') return;
    lp.dataset.initialized = 'true';

    const buyArea = document.querySelector('#dx-product-buy');
    const mobileCta = lp.querySelector('[data-dx-mobile-cta]');
    const quickNav = lp.querySelector('[data-dx-quick-nav]');
    const quickNavSlot = lp.querySelector('[data-dx-quick-nav-slot]');
    const quickNavLinks = quickNav ? [...quickNav.querySelectorAll('a[href^="#"]')] : [];

    let quickNavFrame;
    const updateQuickNavPosition = () => {
      if (!quickNav || !quickNavSlot) return;
      if (quickNavFrame) window.cancelAnimationFrame(quickNavFrame);

      quickNavFrame = window.requestAnimationFrame(() => {
        const stickyHeader = [...document.querySelectorAll('.header__sticky.sticky')]
          .find((element) => {
            const styles = window.getComputedStyle(element);
            const rect = element.getBoundingClientRect();
            return styles.position === 'fixed' && rect.height > 0;
          });
        const headerOffset = stickyHeader ? Math.round(stickyHeader.getBoundingClientRect().height) : 0;
        const shouldFix = quickNavSlot.getBoundingClientRect().top <= headerOffset;
        const navHeight = Math.round(quickNav.getBoundingClientRect().height);
        const productPaneTop = Math.max(112, headerOffset + navHeight + 16);

        quickNav.style.setProperty('--dx-quick-nav-top', `${headerOffset}px`);
        document.documentElement.style.setProperty('--dx-product-pane-top', `${productPaneTop}px`);
        quickNav.classList.toggle('is-fixed', shouldFix);
        quickNavFrame = null;
      });
    };

    updateQuickNavPosition();
    window.addEventListener('scroll', updateQuickNavPosition, { passive: true });
    window.addEventListener('resize', updateQuickNavPosition, { passive: true });

    lp.querySelectorAll('a[href^="#"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const target = document.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        quickNavLinks.forEach((navLink) => navLink.removeAttribute('aria-current'));
        const matchingNavLink = quickNavLinks.find((navLink) => navLink.getAttribute('href') === link.getAttribute('href'));
        matchingNavLink?.setAttribute('aria-current', 'location');

        const navBottom = quickNav ? quickNav.getBoundingClientRect().bottom : 0;
        const destination = window.scrollY + target.getBoundingClientRect().top - navBottom - 12;
        window.scrollTo({ top: Math.max(0, destination), behavior: 'smooth' });
      });
    });

    if ('IntersectionObserver' in window && quickNavLinks.length) {
      const sectionLinks = quickNavLinks
        .map((link) => ({
          link,
          target: document.querySelector(link.getAttribute('href')),
        }))
        .filter((item) => item.target);

      const navObserver = new IntersectionObserver(
        (entries) => {
          const activeEntry = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
          if (!activeEntry) return;

          quickNavLinks.forEach((link) => link.removeAttribute('aria-current'));
          sectionLinks
            .find((item) => item.target === activeEntry.target)
            ?.link.setAttribute('aria-current', 'location');
        },
        {
          rootMargin: '-42% 0px -50% 0px',
          threshold: [0, .1, .35, .7],
        }
      );

      sectionLinks.forEach((item) => navObserver.observe(item.target));
    }

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const motionDelayScale = window.matchMedia('(max-width: 749px)').matches ? 0.65 : 1;
    const motionItems = new Set();

    const registerMotionItem = (element, type = 'reveal', delay = 0) => {
      if (!element || motionItems.has(element)) return;
      motionItems.add(element);
      element.classList.add('dx-motion-item', `dx-motion-${type}`);
      element.style.setProperty('--dx-motion-delay', `${Math.round(delay * motionDelayScale)}ms`);
    };

    const registerMotionGroup = (containerSelector, itemSelector, type = 'card', delayStep = 80) => {
      lp.querySelectorAll(containerSelector).forEach((container) => {
        [...container.querySelectorAll(itemSelector)].forEach((element, index) => {
          registerMotionItem(element, type, Math.min(index * delayStep, 420));
        });
      });
    };

    [
      '.dx-lp__proof-title',
      '.dx-lp__intro',
      '.dx-lp__section-heading',
      '.dx-lp__truth-card',
      '.dx-lp__option-callout',
      '.dx-lp__warranty-kicker',
      '.dx-lp__warranty-heading',
      '.dx-lp__warranty-selector-head',
      '.dx-lp__warranty-selection-status',
      '.dx-lp__warranty-note',
    ].forEach((selector) => {
      lp.querySelectorAll(selector).forEach((element) => registerMotionItem(element, 'reveal'));
    });

    [
      '.dx-lp__split-media',
      '.dx-lp__video',
    ].forEach((selector) => {
      lp.querySelectorAll(selector).forEach((element) => registerMotionItem(element, 'media'));
    });

    registerMotionGroup('.dx-lp__hero-copy', ':scope > *', 'reveal', 90);
    registerMotionGroup(
      '.dx-lp__proof-body',
      ':scope > .dx-lp__proof-number, :scope > .dx-lp__proof-platforms > .dx-lp__proof-number',
      'card',
      90
    );
    registerMotionGroup('.dx-lp__pain-grid', ':scope > article', 'card', 90);
    registerMotionGroup('.dx-lp__mechanism-visual', ':scope > .dx-lp__layer', 'layer', 90);
    registerMotionGroup('.dx-lp__mechanism-copy', ':scope > article', 'reveal', 100);
    registerMotionGroup('.dx-lp__split-copy', ':scope > *', 'reveal', 80);
    registerMotionGroup('.dx-lp__check-list', ':scope > li', 'line', 70);
    registerMotionGroup('.dx-lp__feature-grid', ':scope > article', 'card', 65);
    registerMotionGroup('.dx-lp__evolution-grid', ':scope > article', 'card', 90);
    registerMotionGroup('.dx-lp__scene-grid', ':scope > article', 'card', 80);
    registerMotionGroup('.dx-lp__movie-copy', ':scope > *', 'reveal', 90);
    registerMotionGroup('.dx-lp__step-grid', ':scope > li', 'card', 85);
    registerMotionGroup('.dx-lp__care-list', ':scope > article', 'line', 85);
    registerMotionGroup('.dx-lp__warranty-plans', ':scope > article, :scope > button', 'card', 100);
    registerMotionGroup('.dx-lp__warranty-benefits', ':scope > article', 'line', 80);
    registerMotionGroup('.dx-lp__set-grid', ':scope > article', 'card', 110);
    registerMotionGroup('.dx-lp__faq-list', ':scope > details', 'line', 55);
    registerMotionGroup('.dx-lp__spec-list', ':scope > div', 'line', 45);
    registerMotionGroup('.dx-lp__closing-inner', ':scope > *', 'reveal', 90);

    const heroMedia = lp.querySelector('.dx-lp__hero-media');
    registerMotionItem(heroMedia, 'media', 120);

    const revealAllMotionItems = () => {
      motionItems.forEach((element) => element.classList.add('is-revealed'));
    };

    lp.classList.add('dx-motion-ready');

    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealAllMotionItems();
    } else {
      const motionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-revealed');
            motionObserver.unobserve(entry.target);
          });
        },
        {
          rootMargin: '0px 0px -8% 0px',
          threshold: 0.12,
        }
      );

      motionItems.forEach((element) => motionObserver.observe(element));
    }

    const counters = [...lp.querySelectorAll('[data-dx-countup]')];
    const counterFormatter = (value, decimals) => new Intl.NumberFormat('ja-JP', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(value);

    const prepareCounter = (counter) => {
      const original = counter.textContent.trim();
      const match = original.match(/-?\d[\d,]*(?:\.\d+)?/);
      if (!match) return null;

      const rawNumber = match[0];
      const target = Number(rawNumber.replace(/,/g, ''));
      if (!Number.isFinite(target)) return null;

      const decimalPart = rawNumber.split('.')[1];
      const decimals = decimalPart ? decimalPart.length : 0;
      const matchIndex = match.index || 0;
      const parts = {
        prefix: original.slice(0, matchIndex),
        suffix: original.slice(matchIndex + rawNumber.length),
        target,
        decimals,
      };

      const originalWidth = counter.getBoundingClientRect().width;
      if (originalWidth > 0) counter.style.minWidth = `${Math.ceil(originalWidth)}px`;
      counter.dataset.dxCountOriginal = original;
      counter.setAttribute('aria-label', original);
      counter.textContent = `${parts.prefix}${counterFormatter(0, decimals)}${parts.suffix}`;
      return parts;
    };

    const animateCounter = (counter, parts) => {
      if (counter.dataset.dxCounted === 'true') return;
      counter.dataset.dxCounted = 'true';
      const duration = Number(counter.dataset.dxCountDuration) || 1500;
      const startedAt = performance.now();

      const tick = (now) => {
        const progress = Math.min((now - startedAt) / duration, 1);
        const easedProgress = 1 - Math.pow(1 - progress, 4);
        const current = parts.target * easedProgress;
        counter.textContent = `${parts.prefix}${counterFormatter(current, parts.decimals)}${parts.suffix}`;

        if (progress < 1) {
          window.requestAnimationFrame(tick);
        } else {
          counter.textContent = counter.dataset.dxCountOriginal;
        }
      };

      window.requestAnimationFrame(tick);
    };

    if (!reduceMotion && counters.length) {
      const preparedCounters = counters
        .map((counter) => ({ counter, parts: prepareCounter(counter) }))
        .filter((item) => item.parts);

      if ('IntersectionObserver' in window) {
        const counterObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const item = preparedCounters.find(({ counter }) => counter === entry.target);
              if (item) animateCounter(item.counter, item.parts);
              counterObserver.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -12% 0px', threshold: 0.35 }
        );

        preparedCounters.forEach(({ counter }) => counterObserver.observe(counter));
      } else {
        preparedCounters.forEach(({ counter, parts }) => animateCounter(counter, parts));
      }
    }

    const crossfades = [...lp.querySelectorAll('[data-dx-crossfade]')];
    crossfades.forEach((slideshow) => {
      const slides = [...slideshow.querySelectorAll('[data-dx-crossfade-slide]')];
      const dots = [...slideshow.querySelectorAll('[data-dx-crossfade-dot]')];
      let activeIndex = 0;
      let timer = null;

      const showSlide = (nextIndex) => {
        activeIndex = (nextIndex + slides.length) % slides.length;
        slides.forEach((slide, index) => {
          const isActive = index === activeIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
        dots.forEach((dot, index) => dot.classList.toggle('is-active', index === activeIndex));
      };

      const startSlideshow = () => {
        if (reduceMotion || slides.length < 2 || timer) return;
        timer = window.setInterval(() => showSlide(activeIndex + 1), 3000);
      };

      const stopSlideshow = () => {
        if (!timer) return;
        window.clearInterval(timer);
        timer = null;
      };

      showSlide(0);

      if (reduceMotion) return;

      if ('IntersectionObserver' in window) {
        const slideshowObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                startSlideshow();
              } else {
                stopSlideshow();
              }
            });
          },
          { threshold: 0.2 }
        );
        slideshowObserver.observe(slideshow);
      } else {
        startSlideshow();
      }
    });

    const imageLightbox = lp.querySelector('[data-dx-image-lightbox]');
    if (imageLightbox) {
      const lightboxImage = imageLightbox.querySelector('[data-dx-image-lightbox-image]');
      const lightboxCaption = imageLightbox.querySelector('[data-dx-image-lightbox-caption]');
      const lightboxCount = imageLightbox.querySelector('[data-dx-image-lightbox-count]');
      const lightboxClose = imageLightbox.querySelector('[data-dx-image-lightbox-close]');
      const lightboxPrev = imageLightbox.querySelector('[data-dx-image-lightbox-prev]');
      const lightboxNext = imageLightbox.querySelector('[data-dx-image-lightbox-next]');
      let lightboxItems = [];
      let lightboxIndex = 0;

      const renderLightboxImage = (nextIndex) => {
        if (!lightboxItems.length || !lightboxImage) return;
        lightboxIndex = (nextIndex + lightboxItems.length) % lightboxItems.length;
        const item = lightboxItems[lightboxIndex];
        lightboxImage.src = item.src;
        lightboxImage.alt = item.label;
        if (lightboxCaption) lightboxCaption.textContent = item.label;
        if (lightboxCount) {
          lightboxCount.textContent = lightboxItems.length > 1
            ? `${lightboxIndex + 1} / ${lightboxItems.length}`
            : '';
        }
        const hasMultipleImages = lightboxItems.length > 1;
        if (lightboxPrev) lightboxPrev.hidden = !hasMultipleImages;
        if (lightboxNext) lightboxNext.hidden = !hasMultipleImages;
      };

      const openLightbox = (trigger) => {
        const gallerySlides = [...trigger.querySelectorAll('[data-dx-crossfade-slide]')];
        const baseLabel = trigger.dataset.dxLightboxLabel || 'グリルプレートDX';

        if (gallerySlides.length) {
          lightboxItems = gallerySlides.map((slide, index) => ({
            src: slide.currentSrc || slide.src,
            label: `${baseLabel}（${index + 1}）`,
          }));
          const activeSlideIndex = gallerySlides.findIndex((slide) => slide.classList.contains('is-active'));
          lightboxIndex = activeSlideIndex >= 0 ? activeSlideIndex : 0;
        } else {
          lightboxItems = [{
            src: trigger.dataset.dxLightboxSrc,
            label: baseLabel,
          }].filter((item) => item.src);
          lightboxIndex = 0;
        }

        if (!lightboxItems.length) return;
        renderLightboxImage(lightboxIndex);
        document.body.classList.add('dx-lightbox-open');
        if (typeof imageLightbox.showModal === 'function') {
          imageLightbox.showModal();
        } else {
          imageLightbox.setAttribute('open', '');
        }
        lightboxClose?.focus({ preventScroll: true });
      };

      const closeLightbox = () => {
        if (typeof imageLightbox.close === 'function' && imageLightbox.open) {
          imageLightbox.close();
        } else {
          imageLightbox.removeAttribute('open');
          document.body.classList.remove('dx-lightbox-open');
        }
      };

      lp.querySelectorAll('[data-dx-lightbox-open], [data-dx-lightbox-gallery]').forEach((trigger) => {
        trigger.addEventListener('click', () => openLightbox(trigger));
      });

      lightboxClose?.addEventListener('click', closeLightbox);
      lightboxPrev?.addEventListener('click', () => renderLightboxImage(lightboxIndex - 1));
      lightboxNext?.addEventListener('click', () => renderLightboxImage(lightboxIndex + 1));

      imageLightbox.addEventListener('click', (event) => {
        if (event.target === imageLightbox) closeLightbox();
      });
      imageLightbox.addEventListener('close', () => {
        document.body.classList.remove('dx-lightbox-open');
      });
      imageLightbox.addEventListener('cancel', () => {
        document.body.classList.remove('dx-lightbox-open');
      });
      imageLightbox.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' && lightboxItems.length > 1) {
          event.preventDefault();
          renderLightboxImage(lightboxIndex - 1);
        }
        if (event.key === 'ArrowRight' && lightboxItems.length > 1) {
          event.preventDefault();
          renderLightboxImage(lightboxIndex + 1);
        }
      });
    }

    const warrantySelector = lp.querySelector('[data-dx-warranty-selector]');
    if (warrantySelector) {
      const selectorButtons = [...warrantySelector.querySelectorAll('[data-dx-warranty-select]')];
      const selectorStatus = warrantySelector.querySelector('[data-dx-warranty-status]');
      const selectorClear = warrantySelector.querySelector('[data-dx-warranty-clear]');
      let actualWarrantyGroup = null;
      let actualWarrantyObserver = null;
      let groupLoaderObserver = null;
      let groupLoaderTimer = null;
      let purchaseAreaWarrantyObserver = null;

      const getWarrantyYears = (element) => {
        const match = element?.textContent?.replace(/\s+/g, '').match(/[+＋]([12])年保証/);
        return match ? match[1] : null;
      };

      const findActualWarrantyGroup = () => [...document.querySelectorAll('[role="radiogroup"]')]
        .find((group) => group.querySelector('input[name="properties[_extended_warranty_id]"]'));

      const getActualWarrantyOptions = () => actualWarrantyGroup
        ? [...actualWarrantyGroup.querySelectorAll('[role="radio"]')]
        : [];

      const getActualWarrantyOption = (years) => getActualWarrantyOptions()
        .find((option) => getWarrantyYears(option) === String(years));

      const isActualWarrantyOptionSelected = (option) => option?.getAttribute('aria-checked') === 'true'
        || option?.querySelector('input[name="properties[_extended_warranty_id]"]')?.checked === true;

      const getWarrantyPrice = (option) => {
        const match = option?.textContent?.match(/¥\s*[\d,]+/);
        return match ? match[0].replace(/\s+/g, '') : '';
      };

      const syncWarrantySelector = () => {
        const actualOptions = getActualWarrantyOptions();
        const selectedOption = actualOptions.find(isActualWarrantyOptionSelected);
        const selectedYears = getWarrantyYears(selectedOption);
        const selectedPrice = getWarrantyPrice(selectedOption);

        selectorButtons.forEach((button) => {
          const years = button.dataset.dxWarrantySelect;
          const actualOption = getActualWarrantyOption(years);
          const actualPrice = getWarrantyPrice(actualOption);
          const price = button.querySelector('[data-dx-warranty-price]');
          const isSelected = selectedYears === years;

          if (price && actualPrice) price.textContent = actualPrice;
          button.classList.toggle('is-selected', isSelected);
          button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });

        if (selectorStatus) {
          selectorStatus.textContent = selectedYears
            ? `＋${selectedYears}年保証${selectedPrice ? `（${selectedPrice}）` : ''}を選択中です`
            : '延長保証はまだ選択されていません';
        }
        if (selectorClear) selectorClear.hidden = !selectedOption;
      };

      const bindActualWarrantyGroup = () => {
        const nextGroup = findActualWarrantyGroup();
        if (!nextGroup) return null;
        if (nextGroup === actualWarrantyGroup) return nextGroup;

        actualWarrantyObserver?.disconnect();
        actualWarrantyGroup = nextGroup;
        actualWarrantyGroup.addEventListener('click', () => window.setTimeout(syncWarrantySelector, 0));
        actualWarrantyGroup.addEventListener('change', () => window.setTimeout(syncWarrantySelector, 0));
        actualWarrantyObserver = new MutationObserver(syncWarrantySelector);
        actualWarrantyObserver.observe(actualWarrantyGroup, {
          attributes: true,
          childList: true,
          subtree: true,
          attributeFilter: ['aria-checked', 'class', 'value'],
        });
        syncWarrantySelector();
        return actualWarrantyGroup;
      };

      const selectWarranty = (years, attempts = 0) => {
        bindActualWarrantyGroup();
        const option = getActualWarrantyOption(years);
        if (option) {
          if (!isActualWarrantyOptionSelected(option)) option.click();
          window.setTimeout(syncWarrantySelector, 40);
          return;
        }

        if (attempts < 12) {
          if (selectorStatus) selectorStatus.textContent = '購入欄の延長保証を読み込んでいます…';
          window.setTimeout(() => selectWarranty(years, attempts + 1), 250);
          return;
        }

        if (selectorStatus) {
          selectorStatus.textContent = '購入欄で延長保証を選択してください';
        }
        document.querySelector('#dx-product-buy')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };

      selectorButtons.forEach((button) => {
        button.addEventListener('click', () => selectWarranty(button.dataset.dxWarrantySelect));
      });

      selectorClear?.addEventListener('click', () => {
        bindActualWarrantyGroup();
        const selectedOption = getActualWarrantyOptions().find(isActualWarrantyOptionSelected);
        if (selectedOption) selectedOption.click();
        window.setTimeout(syncWarrantySelector, 40);
      });

      if (!bindActualWarrantyGroup()) {
        groupLoaderObserver = new MutationObserver(() => {
          if (!bindActualWarrantyGroup()) return;
          groupLoaderObserver?.disconnect();
          groupLoaderObserver = null;
          if (groupLoaderTimer) window.clearTimeout(groupLoaderTimer);
        });
        groupLoaderObserver.observe(document.body, { childList: true, subtree: true });
        groupLoaderTimer = window.setTimeout(() => {
          groupLoaderObserver?.disconnect();
          groupLoaderObserver = null;
        }, 15000);
      }

      if (buyArea) {
        purchaseAreaWarrantyObserver = new MutationObserver(bindActualWarrantyGroup);
        purchaseAreaWarrantyObserver.observe(buyArea, { childList: true, subtree: true });
      }
    }

    const videos = [...lp.querySelectorAll('[data-dx-autoplay-video]')];

    const updateVideoToggle = (video) => {
      const toggle = video.parentElement.querySelector('[data-dx-video-toggle]');
      if (!toggle) return;
      const label = toggle.querySelector('[data-dx-video-toggle-label]');
      const isPaused = video.paused;
      toggle.setAttribute('aria-label', isPaused ? '動画を再生' : '動画を一時停止');
      if (label) label.textContent = isPaused ? '再生' : '一時停止';
    };

    videos.forEach((video) => {
      video.muted = true;
      updateVideoToggle(video);
      video.addEventListener('play', () => updateVideoToggle(video));
      video.addEventListener('pause', () => updateVideoToggle(video));

      const toggle = video.parentElement.querySelector('[data-dx-video-toggle]');
      toggle?.addEventListener('click', () => {
        if (video.paused) {
          video.dataset.userPaused = 'false';
          video.play().catch(() => {});
        } else {
          video.dataset.userPaused = 'true';
          video.pause();
        }
      });

      if (reduceMotion) {
        video.autoplay = false;
        video.pause();
        updateVideoToggle(video);
      }
    });

    if (!reduceMotion && 'IntersectionObserver' in window) {
      const videoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
              if (video.dataset.userPaused !== 'true') {
                video.play().catch(() => {});
              }
            } else {
              video.pause();
            }
          });
        },
        { threshold: [0, 0.35, 0.7] }
      );

      videos.forEach((video) => videoObserver.observe(video));
    }

    if (!buyArea || !mobileCta) return;

    const updateMobileCta = () => {
      const buyRect = buyArea.getBoundingClientRect();
      const lpRect = lp.getBoundingClientRect();
      const hasPassedHero = lpRect.top < window.innerHeight * -0.55;
      const isInsideStory = lpRect.bottom > window.innerHeight * 0.25;
      const buyAreaIsAhead = buyRect.top > window.innerHeight * 0.8;
      const shouldShow = hasPassedHero && isInsideStory && buyAreaIsAhead;
      mobileCta.classList.toggle('is-visible', shouldShow);
      mobileCta.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    };

    updateMobileCta();
    window.addEventListener('scroll', updateMobileCta, { passive: true });
    window.addEventListener('resize', updateMobileCta, { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDxLp);
  } else {
    initDxLp();
  }

  document.addEventListener('shopify:section:load', initDxLp);
})();
